<template>
  <v-app>
    <div class="app">
      <aside>
        <MessageCenter />
      </aside>
      <aside>
        <MessageSnackbar v-if="snackbar" />
      </aside>
      <router-view />
    </div>
    <FlagOverrideIndicator />
    <div
      v-if="showBranchName"
      id="version_tag"
    >
      {{ showBranchName }}
    </div>
  </v-app>
</template>

<script>
import MessageCenter from '@/components/MessageCenter/MessageCenter.vue';
import MessageSnackbar from '@/components/MessageCenter/MessageSnackbar.vue';
import FlagOverrideIndicator from '@/components/dev/FlagOverrideIndicator.vue';

import {initialize as initializeAppMonitoring} from '@/services/PostHogService';
import {mapState} from 'vuex';

export default {
  name: 'ExternalApp',
  components: {
    MessageCenter,
    MessageSnackbar,
    FlagOverrideIndicator,
  },
  data() {
    return {
      showBranchName: false,
    };
  },
  computed: {
    ...mapState(['snackbar', 'sharedMap']),
  },
  async created() {
    await initializeAppMonitoring();
  },
  mounted() {
    console.log('Beyond Maps Branch:', process.env.BRANCH_NAME);
    if (process.env.NODE_ENV !== 'production') {
      this.showBranchName = process.env.BRANCH_NAME;
    }
  },
  errorCaptured(err, vm, info) {
    console.error(`error from ${vm.$options?.name} captured in ${this.$options.name}: ${info}\n`, err);
    // Prevent errors from crashing the app and causing it to stop working.
    return false;
  },
};
</script>
<style lang="scss"> // eslint-disable-line vue-scoped-css/enforce-style-type
// Set your colors
$primary: rgb(235, 153, 63);
$primary-invert: findColorInvert($primary);
$npOrange: rgb(235, 153, 63);
$npOrange-invert: findColorInvert($npOrange);
// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Buttons
$button-border-color: main.$npOrange;
$button-border-width: 0.5px;
$button-focus-color: $primary;

a {
  color: white;
  background-color: transparent;
  font-size: 16px;
  font-weight: 150;
  padding: 5px;
}

a:hover {
  color: grey
}

</style>
<style lang="scss" scoped>
.app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#version_tag {
  position: absolute;
  z-index: 2000;
  background: rgb(208, 0, 0);
  color: rgb(255, 255, 255);
  bottom: 0px;
  right: 0px;
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 0.65rem;
  padding: 0.2rem;
}
</style>
